export const cMembershipList = {
  1: "일반회원",
  2: "월간회원",
  3: "일년회원",
  4: "평생회원",
};
